import { Component, input } from '@angular/core';
import { RestrictedClient } from '../../../api/app-types/client.app';
import { CUSTOM_DATE_FORMATS } from '../../../core/adapters/custom-date-format';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'lvr-client-restricted-details-view',
	imports: [MatIcon, TranslocoPipe, DatePipe],
	templateUrl: './client-restricted-details-view.html',
	styleUrl: './client-restricted-details-view.scss',
})
export class ClientRestrictedDetailsView {
	public client = input<RestrictedClient | undefined>();
	public readonly dateDisplayFormat = CUSTOM_DATE_FORMATS.display.dateInput;

	/**
	 * Checks if the given date string is valid and different from the default DateOnly.MinValue ('0001-01-01'),
	 * which is returned by the backend when no date is provided.
	 * @param input - Date string to validate.
	 * @returns true if the date is valid and not the default min value.
	 */
	public isValidDate(input?: Date | string) {
		if (!input) {
			return false;
		}

		const date = new Date(input);
		if (Number.isNaN(date.getTime())) {
			return false;
		}

		// Check if it's the default '0001-01-01'
		const isMinDate = date.getFullYear() === 1 && date.getMonth() === 0 && date.getDate() === 1;

		return !isMinDate;
	}
}
